<template>
  <div class="row" v-if="!isLoading">
    <div class="col-12">
      <img class="mt-3" :srcset="`${logo} 3x`" />
      <p class="mt-4 mb-3">
        {{ $t('SETTINGS.TEXT.ADD_YOUR_FACEBOOK_PIXEL_CODE') }}
      </p>
      <div class="mb-4 d-flex align-items-center">
        <font-awesome-icon
          class="text-primary mr-2"
          :icon="['far', 'info-circle']"
        />
        <a
          href="https://www.facebook.com/business/help/952192354843755?helpref=faq_content"
          target="_blank"
        >
          {{ $t('SETTINGS.LINK.NEED_HELP_FINDING_YOUR_PIXEL_ID') }}
        </a>
      </div>
    </div>
    <div class="col-12">
      <HMTextInput
        :label="$t('SETTINGS.LABEL.FACEBOOK_PIXEL_ID')"
        v-model="FBPixel"
      />
    </div>
    <!--    <hr class="mx-3 w-100" />-->
    <div class="col-12 form-group">
      <HMButton color="primary" @click="update" :loading="inProgress">
        {{ $t('SETTINGS.BUTTON.UPDATE') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  data() {
    return {
      logo: '/assets/images/integrations/facebook-pixel@3x.png',
      isLoading: true,
      inProgress: false,
      FBPixel: null,
    };
  },
  methods: {
    async update() {
      this.inProgress = true;
      try {
        await this.$store.dispatch('setting/updateFBPixelID', this.FBPixel);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'SETTINGS.NOTIFICATIONS.FACEBOOK_PIXEL_ID_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.FBPixel = null;
      this.update();
    },
  },
  async mounted() {
    this.FBPixel = await this.$store.dispatch('setting/getFBPixelID');
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
